import { Controller } from "@hotwired/stimulus"

// Adapts the enquiry form to the selected enquiry type without reloading, so anything the
// visitor has already typed is kept. The rules come from Contact::REQUIRED_FIELDS and
// Contact::HIDDEN_FIELDS (passed in as a value) and mirror the server-side validations.
export default class extends Controller {
  static targets = ["service", "field", "show", "summary", "networkError", "submit"]
  static values = { rules: Object }

  connect() {
    this.apply()
    if (this.hasSummaryTarget) this.summaryTarget.focus()
  }

  update() {
    this.apply()
  }

  get service() {
    return this.serviceTarget.value
  }

  get branch() {
    return ["quick_check", "assessment"].includes(this.service) ? this.service : "general"
  }

  apply() {
    const branch = this.branch
    const required = this.rulesValue.required[branch] || []
    const hidden = this.rulesValue.hidden[branch] || []

    this.fieldTargets.forEach((field) => {
      const name = field.dataset.field
      const input = field.querySelector("input, textarea")
      const isHidden = hidden.includes(name)
      const isRequired = required.includes(name)

      field.classList.toggle("hidden", isHidden)
      if (input) {
        input.disabled = isHidden
        input.required = isRequired
        input.setAttribute("aria-required", String(isRequired))
        const placeholder = input.dataset[`placeholder${this.camelize(branch)}`]
        if (placeholder) input.placeholder = placeholder
      }
      field.querySelectorAll("[data-marker='required']").forEach((el) => el.classList.toggle("hidden", !isRequired))
      field.querySelectorAll("[data-marker='optional']").forEach((el) => el.classList.toggle("hidden", isRequired))
    })

    const tokens = [branch, this.service || "none"]
    this.showTargets.forEach((el) => {
      const wanted = el.dataset.showFor.split(" ")
      el.classList.toggle("hidden", !wanted.some((token) => tokens.includes(token)))
    })
  }

  // Replaces the browser's default bubble text with the site's own wording.
  invalid(event) {
    const input = event.target
    const key = input.validity.valueMissing ? "msgBlank" : "msgInvalid"
    const message = input.dataset[key]
    if (message) input.setCustomValidity(message)
  }

  clearValidity(event) {
    event.target.setCustomValidity?.("")
  }

  submitStart() {
    if (this.hasNetworkErrorTarget) this.networkErrorTarget.classList.add("hidden")
  }

  // Raised by Turbo when the request itself failed, so it is unknown whether the enquiry was stored.
  networkError() {
    if (!this.hasNetworkErrorTarget) return
    this.networkErrorTarget.classList.remove("hidden")
    this.networkErrorTarget.focus()
  }

  camelize(value) {
    return value.replace(/(^|_)(\w)/g, (_, __, char) => char.toUpperCase())
  }
}
